"use client";

import { c as _c } from "react/compiler-runtime";
import { Section } from "@/components/section";
import { useServiceContent } from "@/hooks/use-service-content";
import { CircleCheck } from "lucide-react";
type KeyFeaturesProps = {
  section: PageSections;
  data: {
    keyFeatures: ServiceContent;
  };
};
const KeyFeatures = t0 => {
  const $ = _c(11);
  const {
    data,
    section
  } = t0;
  const {
    heading,
    seoHeading,
    list
  } = useServiceContent(data.keyFeatures);
  const t1 = `${section.sectionClass} from-background bg-linear-to-b to-rose-50 dark:to-transparent`;
  let t2;
  if ($[0] !== list) {
    t2 = list?.map(_temp);
    $[0] = list;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t2) {
    t3 = <ul className="space-y-2 sm:columns-2">{t2}</ul>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== heading || $[5] !== section.name || $[6] !== section.sectionId || $[7] !== seoHeading || $[8] !== t1 || $[9] !== t3) {
    t4 = <Section className={t1} id={section.sectionId} data-title={section.name} seoTitle={seoHeading} title={heading}>{t3}</Section>;
    $[4] = heading;
    $[5] = section.name;
    $[6] = section.sectionId;
    $[7] = seoHeading;
    $[8] = t1;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
export default KeyFeatures;
function _temp(item, index) {
  return <li key={`key-features-${index}`} className="flex items-center gap-3"><CircleCheck size={20} className="text-primary shrink-0" /><span>{item}</span></li>;
}